import { IconFunctionalHouse16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './NoLogo.css';

export function NoLogo() {
  return (
    <div className={styles['container']}>
      <IconFunctionalHouse16 color="gray40_100" />
    </div>
  );
}
